import * as React from 'react';

import MaskedInput, { Mask } from 'react-text-mask';

import FormControl from '@material-ui/core/FormControl';
import FormHelperText from '@material-ui/core/FormHelperText';
import Input from '@material-ui/core/Input';
import InputLabel from '@material-ui/core/InputLabel';
import { TEXT } from 'texts';
import { observer } from 'mobx-react-lite';
import { useStores } from 'hooks';
import { useTranslation } from 'react-i18next';

const TextMaskCustom = (props: { inputRef?: (el: HTMLInputElement) => void; onChange?(value: unknown): void }) => {
  const { inputRef, ...other } = props;
  const mask = Array.from({ length: 25 }).fill(/^[a-zA-Z \-']/) as Mask;
  return (
    <MaskedInput
      {...other}
      ref={(ref: any) => {
        inputRef && inputRef(ref ? ref.inputElement : null);
      }}
      mask={mask}
      showMask={false}
      guide={false}
    />
  );
};

const NameInput = () => {
  const { t } = useTranslation();

  const { formStore } = useStores();

  const handleChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    const { value } = event.currentTarget;
    formStore.name.setValue(value);
  };

  const handleBlur = () => formStore.name.validate();

  const renderError = () => {
    if (formStore.name.error) {
      return t(formStore.name.error);
    }
    return ' ';
  };

  return (
    <FormControl fullWidth>
      <InputLabel htmlFor="name">{t(TEXT.nameLabel)}</InputLabel>
      <Input
        id="name"
        value={formStore.name.value}
        onChange={handleChange}
        onBlur={handleBlur}
        type="text"
        inputMode="text"
        inputComponent={TextMaskCustom}
      />
      <FormHelperText id="address-helper" error={!!formStore.name.error}>
        {renderError()}
      </FormHelperText>
    </FormControl>
  );
};

export default observer(NameInput);
